import { fetchBnftPlanCompProvFact, fetchGetLatestTemplateRiderComponent, fetchTemplateRiderComp } from "./apiUtils";
const accumMapping = require('./../mapping/accum-mapping.json')
const _ = require('lodash')

const findMatchingAccumulators = (accum) => {
  const matches = accumMapping.filter(r => {
    var match = true

    if (accum?.medical?.inNetwork?.deductible?.type != undefined && !_.isEqual(accum.medical.inNetwork.deductible.type, r.medical.inNetwork.deductible.type)) match = false
    if (accum?.medical?.inNetwork?.outOfPocket?.type != undefined && !_.isEqual(accum.medical.inNetwork.outOfPocket.type, r.medical.inNetwork.outOfPocket.type)) match = false
    if (accum?.medical?.inNetwork?.deductible?.tierDeductibleSharing != undefined && accum.medical.inNetwork.deductible.tierDeductibleSharing != r.medical.inNetwork.deductible.tierDeductibleSharing) match = false
    if (accum?.medical?.inNetwork?.outOfPocket?.tierOutOfPocketSharing != undefined && accum.medical.inNetwork.outOfPocket.tierOutOfPocketSharing != r.medical.inNetwork.outOfPocket.tierOutOfPocketSharing) match = false
    if (accum?.medical?.inNetwork?.deductible?.productTypeDeductibleSharing != undefined && accum.medical.inNetwork.deductible.productTypeDeductibleSharing != r.medical.inNetwork.deductible.productTypeDeductibleSharing) match = false
    if (accum?.medical?.inNetwork?.outOfPocket?.productTypeOutOfPocketSharing != undefined && accum.medical.inNetwork.outOfPocket.productTypeOutOfPocketSharing != r.medical.inNetwork.outOfPocket.productTypeOutOfPocketSharing) match = false

    if (accum?.medical?.outOfNetwork?.deductible?.type != undefined && !_.isEqual(accum.medical.outOfNetwork.deductible.type, r.medical.outOfNetwork.deductible.type)) match = false
    if (accum?.medical?.outOfNetwork?.outOfPocket?.type != undefined && !_.isEqual(accum.medical.outOfNetwork.outOfPocket.type, r.medical.outOfNetwork.outOfPocket.type)) match = false
    if (accum?.medical?.outOfNetwork?.deductible?.tierDeductibleSharing != undefined && accum.medical.outOfNetwork.deductible.tierDeductibleSharing != r.medical.outOfNetwork.deductible.tierDeductibleSharing) match = false
    if (accum?.medical?.outOfNetwork?.outOfPocket?.tierOutOfPocketSharing != undefined && accum.medical.outOfNetwork.outOfPocket.tierOutOfPocketSharing != r.medical.outOfNetwork.outOfPocket.tierOutOfPocketSharing) match = false
    if (accum?.medical?.outOfNetwork?.deductible?.productTypeDeductibleSharing != undefined && accum.medical.outOfNetwork.deductible.productTypeDeductibleSharing != r.medical.outOfNetwork.deductible.productTypeDeductibleSharing) match = false
    if (accum?.medical?.outOfNetwork?.outOfPocket?.productTypeOutOfPocketSharing != undefined && accum.medical.outOfNetwork.outOfPocket.productTypeOutOfPocketSharing != r.medical.outOfNetwork.outOfPocket.productTypeOutOfPocketSharing) match = false

    if (accum?.prescription?.inNetwork?.deductible?.type != undefined && !_.isEqual(accum.prescription.inNetwork.deductible.type, r.prescription.inNetwork.deductible.type)) match = false
    if (accum?.prescription?.inNetwork?.outOfPocket?.type != undefined && !_.isEqual(accum.prescription.inNetwork.outOfPocket.type, r.prescription.inNetwork.outOfPocket.type)) match = false
    if (accum?.prescription?.inNetwork?.deductible?.tierDeductibleSharing != undefined && accum.prescription.inNetwork.deductible.tierDeductibleSharing != r.prescription.inNetwork.deductible.tierDeductibleSharing) match = false
    if (accum?.prescription?.inNetwork?.outOfPocket?.tierOutOfPocketSharing != undefined && accum.prescription.inNetwork.outOfPocket.tierOutOfPocketSharing != r.prescription.inNetwork.outOfPocket.tierOutOfPocketSharing) match = false
    if (accum?.prescription?.inNetwork?.deductible?.productTypeDeductibleSharing != undefined && accum.prescription.inNetwork.deductible.productTypeDeductibleSharing != r.prescription.inNetwork.deductible.productTypeDeductibleSharing) match = false
    if (accum?.prescription?.inNetwork?.outOfPocket?.productTypeOutOfPocketSharing != undefined && accum.prescription.inNetwork.outOfPocket.productTypeOutOfPocketSharing != r.prescription.inNetwork.outOfPocket.productTypeOutOfPocketSharing) match = false

    if (accum?.prescription?.outOfNetwork?.deductible?.type != undefined && !_.isEqual(accum.prescription.outOfNetwork.deductible.type, r.prescription.outOfNetwork.deductible.type)) match = false
    if (accum?.prescription?.outOfNetwork?.outOfPocket?.type != undefined && !_.isEqual(accum.prescription.outOfNetwork.outOfPocket.type, r.prescription.outOfNetwork.outOfPocket.type)) match = false
    if (accum?.prescription?.outOfNetwork?.deductible?.tierDeductibleSharing != undefined && accum.prescription.outOfNetwork.deductible.tierDeductibleSharing != r.prescription.outOfNetwork.deductible.tierDeductibleSharing) match = false
    if (accum?.prescription?.outOfNetwork?.outOfPocket?.tierOutOfPocketSharing != undefined && accum.prescription.outOfNetwork.outOfPocket.tierOutOfPocketSharing != r.prescription.outOfNetwork.outOfPocket.tierOutOfPocketSharing) match = false
    if (accum?.prescription?.outOfNetwork?.deductible?.productTypeDeductibleSharing != undefined && accum.prescription.outOfNetwork.deductible.productTypeDeductibleSharing != r.prescription.outOfNetwork.deductible.productTypeDeductibleSharing) match = false
    if (accum?.prescription?.outOfNetwork?.outOfPocket?.productTypeOutOfPocketSharing != undefined && accum.prescription.outOfNetwork.outOfPocket.productTypeOutOfPocketSharing != r.prescription.outOfNetwork.outOfPocket.productTypeOutOfPocketSharing) match = false

    return match
  })

  return matches
}

const extractQuoted = (str) => str.match(/"([^"]*)"/g).map(s => s.replace(/"/g, ""))

const extractFact = (str, pattern) => {
  let extracted = str.match(pattern)
  if (extracted) extracted = extracted.map(extractQuoted).flat()
  return extracted
}

const parseProvision = (provision) => {
  const text = provision.benefitProvisionText

  let tier = text.includes("INN") ? "INN" : "OON"
  let networks = extractFact(text, /benefit networks "([^]*" and)/g)
  let serviceCategories = extractFact(text, /service category "([^]*" (\) is|is|, delivered))/g)
  let coinsuranceVar = extractFact(text, /is "([^]*")/g)
  let copayVar = extractFact(text, /copay of "([^]*")/g)

  let coverageType
  if (copayVar && !text.includes("deductible waived")) {
    coverageType = "CPY+DED"
  } else if (copayVar) {
    coverageType = "CPY"
  } else if (text.includes("deductible waived")) {
    coverageType = "DWV"
  } else {
    coverageType = "DED"
  }

  if (serviceCategories) {
    serviceCategories = serviceCategories.filter(s => !s.includes('PCP') && !s.includes('Referral') && !(s.includes('Place of Service')))
  }
  let vars = []
  if (coinsuranceVar && coinsuranceVar.length > 0) vars.push(coinsuranceVar[0])
  if (copayVar && copayVar.length > 0) vars.push(copayVar[0])

  return {
    text,
    tier,
    networks,
    serviceCategories,
    vars,
    coverageType,
    pcp: text.includes('PCP'),
    referral: text.includes('Referral')
  }
}

const parseRider = (rider) => {
  let parsedProvisions = rider.provisions.map(parseProvision)

  let pcp = parsedProvisions.filter(p => p.pcp).length > 0
  let referral = parsedProvisions.filter(p => p.referral).length > 0

  let serviceCategories = {}
  parsedProvisions
    .filter(p => p.tier == "INN")
    .forEach(p => {
      if (p.serviceCategories) {
        p.serviceCategories.forEach(s => {
          if (!(s in serviceCategories)) {
            serviceCategories[s] = {
              coverageTypes: new Set(),
              pcp: p.pcp,
              referral: p.referral,
            }
          }
          serviceCategories[s].coverageTypes.add(p.coverageType)
        })
      }
    })

  let vars = [...new Set(parsedProvisions
    .filter(p => p.vars)
    .map(p => p.vars)
    .flat())]

  return {
    ...rider,
    parsedProvisions,
    riderInfo: {
      serviceCategories,
      vars,
      pcp,
      referral,
    }
  }
}

const parseRiders = (riders) => {
  const parsedRiders = riders.map(parseRider)

  let serviceCategories = new Set()
  parsedRiders.forEach(r => {
    for (const serviceCategory of Object.keys(r.riderInfo.serviceCategories)) {
      if (!serviceCategory.match(/[\d]+/g)) {
        serviceCategories.add(serviceCategory)
      }
    }
  })
  serviceCategories = [...serviceCategories]

  const pcp = parsedRiders.filter(r => r.riderInfo.pcp).length > 0
  const referral = parsedRiders.filter(r => r.riderInfo.referral).length > 0

  return {
    parsedRiders,
    serviceCategories,
    pcp,
    referral,
  }
}

const HRL_KEYWORDS = {
  // Variables in bold green
  // Quoted non-labels in bold blue
  // Strong highlights in bold red
  'strong': [
    "penalty",
    "repricer",
    "user message code",
    "system message code",
    "modifier",
    "no reimbursement",
    "member age (?:>=|<=|>|<) [\\d]+ years?",
    "member age between [\\d]+ and [\\d]+ months",
    "member age <= [\\d]+ years until end of calendar year",
    "member age <= [\\d]+ years until end of calendar month",
    "member is compliant with program",
    "member is not compliant with program",
    "member with health condition",
    "apply message even when no financial penalty",
    // "per plan year",
    "per day for the same practitioner",
    "per day for the same supplier",
    "per day for the same claim",
  ],
  // Modifier highlights in bold blue
  'modifier': [
    "rendered by member's pcp",
    "rendered by a practitioner in a pcp role",
    "rendered by member’s pcp referral circle",
  ],
  // Light highlights in bold
  'light': [
    "deductible",
    "waived",
    "copay",
    "coinsurance",
    "out of pocket maximum"
  ],
}

const getKeywordRegex = (type) => {
  if (!(type in HRL_KEYWORDS)) {
    throw Exception('Invalid keyword regex type')
  }

  return new RegExp(`(${HRL_KEYWORDS[type].join("|")})`, "gi")
}

const getCategoryRiders = async (templateKey, category) => {
  // const data = await fetchTemplateRiderComp({
  //   category,
  //   benefitPlanTemplateKey: templateKey,
  //   size: 1000,
  // })

  // return data.hits.hits.map(({ _source: { metadata } }) => metadata)

  const data = await fetchGetLatestTemplateRiderComponent({

    benefitPlanTemplateKey: templateKey,
    slotName: category,
    limit: 100
  })
  return data.rows

}

const getRiderProvisions = async (key) => {
  // Filter by the requested key after getting results because HRP
  const res = await fetchBnftPlanCompProvFact({
    bnftPlanCompHistFactKey: key,
    limit: 500,
  })
  return res.filter(r => r.bnftPlanCompHistFactKey == key)
}

const getRiderByName = async (templateKey, category, name) => {
  const results = await getCategoryRiders(templateKey, category)
  return results.find(h => h.benefitPlanCompName == name)
}

const getProvisionsByName = async (templateKey, category, name) => {
  const rider = await getRiderByName(templateKey, category, name)
  const provisions = await getRiderProvisions(rider?.bnftPlanCompHistFactKey)
  return {
    ...rider,
    provisions,
  }
}

const getVendorProvisionsByName = async (templateKey, name) => {
  const results = await fetchTemplateRiderComp({
    size: 100,
    benefitPlanTemplateKey: templateKey,
    searchText: 'Vendor ',
    filterText: 'Invoices'
  })
  const result = results.hits.hits.map(hit => hit._source.metadata)
    .find(r => r.benefitPlanCompName == name)
  return await getRiderProvisions(result?.bnftPlanCompHistFactKey)
}

const parseProvisionVars = (provisionText) => {
  let regex = /(?:is|copay of) "([^"]*)"/g
  return extractFact(provisionText, regex)
}

export {
  findMatchingAccumulators,
  parseRider,
  parseRiders,
  getKeywordRegex,
  getCategoryRiders,
  getRiderProvisions,
  getRiderByName,
  getProvisionsByName,
  getVendorProvisionsByName,
  parseProvisionVars,
}
